/* Hello couleur — cross-sell dynamique via l'API Product Recommendations Shopify.
   Deux emplacements alimentes par ce meme script :
   - Fiche produit : grille [data-reco-grid] (« Vous aimerez aussi »), 4 cartes.
   - Panier        : grille [data-cart-reco-grid] (« Ajoutez aussi »), 3 cartes.

   Strategie 2 couches (anti-bloc-vide au lancement = « H zero ») :
   1. Le serveur (Liquid) rend deja un FOND de cartes pertinentes → jamais de bloc vide,
      meme tant que Shopify n'a aucune donnee de co-achat (boutique neuve, 0 trafic).
   2. Ce script interroge Shopify (/recommendations/products.json, intent=related,
      base sur les co-achats/co-vues reels) et place ces reco EN TETE de la grille ;
      il complete avec le fond pour atteindre le quota, en dedupliquant.
   Resultat : au lancement = 100 % fond ; une fois des ventes accumulees = 100 % reco
      (bascule automatique, zero maintenance). */
(function () {
  var RECENT_KEY = 'hc_recent_v1';

  function recentSlugs() {
    try {
      var arr = JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
      var set = {};
      arr.forEach(function (x) { if (x && x.slug) set[x.slug] = true; });
      return set;
    } catch (e) { return {}; }
  }

  // Handle d'une carte : attribut explicite sinon extrait de l'URL /products/<handle>.
  function cardHandle(node) {
    var h = node.getAttribute('data-reco-handle');
    if (h) return h;
    var href = node.getAttribute('href') || '';
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function fmtPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  // Libelle categorie : meme mapping que hc-card-product.liquid (respect maquette).
  var TYPE_LABELS = {
    'carnet-a5': 'Carnet A5',
    'carnet-de-poche': 'Carnet de poche',
    'bloc-notes': 'Bloc-notes',
    'carte-pliee': 'Carte pliée',
    'mini-carte-pliee': 'Mini carte',
    'petit-pack': 'Petit pack',
    'pack': 'Pack',
    'pack-standard': 'Pack',
    'grand-pack': 'Grand pack',
    'gros-pack': 'Grand pack',
    'pack-cartes': 'Pack de cartes',
    'pack-carnets': 'Duo de carnets',
    'pack-blocs': 'Pack 3 blocs',
    'coffret': 'Coffret',
    'planche-stickers': 'Planche de stickers'
  };
  function catLabel(type) {
    if (!type) return 'Hello couleur';
    var t = String(type).toLowerCase();
    if (TYPE_LABELS[t]) return TYPE_LABELS[t];
    if (t.indexOf('tirage') !== -1) return "Tirage d'art";
    if (t.indexOf('peinture') !== -1 || t.indexOf('originale') !== -1) return 'Peinture originale';
    if (t.indexOf('sticker') !== -1) return 'Planche de stickers';
    // Repli : type brut avec tirets remplaces, 1re lettre en majuscule.
    var s = t.replace(/-/g, ' ');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Familles packs/coffrets/stickers : image non rognee (parite avec hc-card-product).
  var CONTAIN_TYPES = {
    'petit-pack': 1, 'pack': 1, 'pack-standard': 1, 'grand-pack': 1, 'gros-pack': 1,
    'pack-cartes': 1, 'pack-carnets': 1, 'pack-blocs': 1, 'coffret': 1, 'planche-stickers': 1
  };

  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // Ajout 2026-08-07 : srcset pour les cartes construites en JS.
  // Sans lui, ces cartes servaient une image 600 px meme sur un mobile de 343 px de large,
  // alors que le HTML rendu par Liquid porte deja un srcset. Largeurs mesurees le 2026-08-07 :
  // 282 px en desktop 1280, 343 px en mobile 375.
  var CARD_WIDTHS = [300, 450, 600, 800];
  function srcsetFor(url) {
    if (!url) return '';
    return CARD_WIDTHS.map(function (w) { return sized(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  function escAttr(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function escHtml(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Construit une carte .product-card a partir d'un objet produit de recommendations.json.
  function buildCard(p) {
    var a = document.createElement('a');
    a.href = p.url;
    a.className = 'product-card';
    a.setAttribute('data-reco-handle', p.handle);
    // Pour l'ajout en un clic depuis le panneau panier (hc-cart-panel.js).
    var v0 = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
    if (v0) { a.setAttribute('data-variant-id', v0.id); a.setAttribute('data-price-cents', v0.price); }
    var t = (p.type || '').toLowerCase();
    var contain = (CONTAIN_TYPES[t] || t.indexOf('sticker') !== -1) ? ' product-card__image--contain' : '';
    var raw = (p.featured_image && typeof p.featured_image === 'string')
      ? p.featured_image
      : (p.featured_image && p.featured_image.src) || '';
    var img = sized(raw, 600);
    var price = (typeof p.price_min === 'number') ? p.price_min : p.price;
    // 2026-10-28 : pour un pro (window.HC_B2B), prix de depart = le moins cher des formats, pas le dernier palier.
    if (window.HC_B2B && p.variants && p.variants.length) {
      price = Math.min.apply(null, p.variants.map(function (v) { return v.price; }));
    }
    a.innerHTML =
      '<div class="product-card__image' + contain + '">' +
        (img ? '<img loading="lazy" decoding="async" src="' + escAttr(img) +
               '" srcset="' + escAttr(srcsetFor(raw)) +
               '" sizes="(min-width: 750px) 300px, 92vw" alt="' +
               escAttr(p.title) + '" width="600" height="600">' : '') +
      '</div>' +
      '<div class="product-card__body">' +
        '<p class="product-card__category">' + escHtml(catLabel(p.type)) + '</p>' +
        '<h3 class="product-card__title">' + escHtml(p.title) + '</h3>' +
        '<p class="product-card__price">' + fmtPrice(price) + '</p>' +
      '</div>';
    return a;
  }

  function fetchRecos(productId, limit) {
    var url = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
              '&limit=' + limit + '&intent=related';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return (d && d.products) || []; })
      .catch(function () { return []; });
  }

  // Fusionne reco (en tete) + fond serveur, deduplique, montre les N premieres.
  // excludeSet = handles a ne jamais montrer (recemment vus, ou deja au panier).
  function mergeAndPaint(grid, recoCards, fallbackCards, show, excludeSet) {
    var used = {};
    var ordered = [];
    function push(node) {
      var h = cardHandle(node);
      if (!h || used[h] || excludeSet[h]) return;
      used[h] = true;
      ordered.push(node);
    }
    recoCards.forEach(push);
    fallbackCards.forEach(push);
    // Garde-fou : si tout a ete filtre (ex. tout deja vu), on retombe sur le fond brut.
    if (ordered.length === 0) ordered = fallbackCards;
    grid.innerHTML = '';
    ordered.slice(0, show).forEach(function (c) { c.hidden = false; grid.appendChild(c); });
  }

  // ── Fiche produit : « Vous aimerez aussi » (4 cartes, hors articles deja vus) ──
  function initProduct() {
    var grid = document.querySelector('[data-reco-grid]');
    if (!grid) return;
    // 2026-10-01 : mobile = bande qui défile (10 cartes), ordinateur = 4 cartes.
    var SHOW = window.matchMedia('(max-width: 749px)').matches ? 10 : 4;
    var productId = grid.getAttribute('data-product-id');
    var exclude = recentSlugs();
    var fallback = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));

    if (!productId) { mergeAndPaint(grid, fallback, [], SHOW, exclude); return; }
    fetchRecos(productId, 10).then(function (products) {
      var cards = products.filter(function (p) { return p && p.handle; }).map(buildCard);
      // 2026-10-01 (Olivier) : les cartes du serveur (visuel proche : même motif, même thème) passent EN TÊTE ;
      // les suggestions Shopify (co-achats) ne font plus que compléter.
      mergeAndPaint(grid, fallback, cards, SHOW, exclude);
    });
  }

  // ── Panier : « Ajoutez aussi » (3 cartes, hors articles deja au panier) ──
  function initCart() {
    var grid = document.querySelector('[data-cart-reco-grid]');
    if (!grid) return;
    var SHOW = 3;
    var seedId = grid.getAttribute('data-seed-id');
    var exclude = {};
    (grid.getAttribute('data-cart-handles') || '').split(',').forEach(function (h) {
      if (h) exclude[h] = true;
    });
    var fallback = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));

    if (!seedId) { mergeAndPaint(grid, [], fallback, SHOW, exclude); return; }
    fetchRecos(seedId, 10).then(function (products) {
      var cards = products.filter(function (p) { return p && p.handle; }).map(buildCard);
      mergeAndPaint(grid, cards, fallback, SHOW, exclude);
    });
  }

  function init() { initProduct(); initCart(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
